import { Badge } from "@portal/ui";

export const PROJECT_STATUS_LABELS = {
  ACTIVE: "進行中",
  ENDED: "終了",
  ARCHIVED: "アーカイブ",
} as const;
export const CUSTOMER_RELATION_LABELS = {
  CLIENT: "顧客",
  PARTNER: "協力会社",
  OTHER: "その他",
} as const;
export const PARTICIPANT_SOURCE_LABELS = {
  MANUAL: "手動",
  BACKLOG: "Backlog",
  SHEET: "シート",
} as const;

export function ProjectStatusBadge({ status }: { status: keyof typeof PROJECT_STATUS_LABELS }) {
  const variant = status === "ACTIVE" ? "success" : status === "ENDED" ? "neutral" : "outline";
  return <Badge variant={variant}>{PROJECT_STATUS_LABELS[status]}</Badge>;
}
